import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import axiosInstance from "../../../axiosInstance";
import toast from "react-hot-toast";

const AllNotification = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get("/admin/notifications?limit=50");
      setNotifications(data.notifications || []);
      setUnreadCount(data.unreadCount || 0);
    } catch (error) {
      toast.error(error.response?.data?.message || "Error fetching notifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const markRead = async (id) => {
    try {
      await axiosInstance.put(`/admin/notifications/${id}/read`);
      fetchNotifications();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating notification");
    }
  };

  const markAllRead = async () => {
    try {
      await axiosInstance.put("/admin/notifications/read-all");
      fetchNotifications();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating notifications");
    }
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4 d-flex justify-content-between align-items-center">
          <div>
            <h1 className="h4 mb-1">Notifications</h1>
            <p className="mb-0 text-muted">{unreadCount} unread notification(s)</p>
          </div>
          <button className="btn btn-secondary" type="button" onClick={markAllRead}>
            Mark all read
          </button>
        </div>

        <div className="card border-0 shadow">
          <div className="card-body">
            {loading ? (
              <p className="mb-0">Loading...</p>
            ) : notifications.length === 0 ? (
              <p className="mb-0">No notifications found.</p>
            ) : (
              <div className="list-group list-group-flush">
                {notifications.map((item) => (
                  <div
                    key={item._id}
                    className={`list-group-item px-0 d-flex justify-content-between gap-3 ${!item.isRead ? "bg-light" : ""}`}
                  >
                    <div>
                      <span className={`badge me-2 ${item.type === "order" ? "bg-primary" : "bg-info"}`}>
                        {item.type}
                      </span>
                      <strong>{item.title}</strong>
                      <p className="mb-1">{item.message}</p>
                      <small className="text-muted">{formatDate(item.createdAt)}</small>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      {item.refModel === "Order" && item.refId && (
                        <Link className="btn btn-sm btn-outline-primary" to={`/order/${item.refId}`}>
                          View
                        </Link>
                      )}
                      {!item.isRead && (
                        <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => markRead(item._id)}>
                          Read
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default AllNotification;
